<template>
    <component :is="tag"
        :type="actionless ? undefined : 'button'"
        :disabled="disabled"
        class="group flex items-center px-md py-sm text-left"
        :class="{
            'bg-gray-100 text-gray-500': disabled
        }">
        <v-icon :icon="icon"
            class="mr-sm h-sm"></v-icon>

        <span class="text-sm tracking-xl"
            :class="{
                'group-hover:underline': !actionless && !disabled,
            }">
            <slot></slot>
        </span>

        <v-icon v-if="!actionless"
            icon="chevron-right"
            class="ml-auto text-xl"></v-icon>
    </component>
</template>

<script lang="ts" setup>
import type { Icon } from '~~/types';

const properties = defineProps<{
    icon: Icon
    actionless?: boolean
    disabled?: boolean
}>();

const tag = computed(() => {
    if (properties.actionless) {
        return 'div';
    }

    return 'button';
});
</script>
